import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { i18n } from 'config/locales';
import { MILITARY } from 'constants/sections';
import { formTypes } from 'config/formTypes';
import { ErrorList } from 'components/ErrorList';
import SectionNavigation from 'components/Section/shared/SectionNavigation';
import Selective from 'components/Section/Military/Selective';
import History from 'components/Section/Military/History';
import Disciplinary from 'components/Section/Military/Disciplinary';
import Foreign from 'components/Section/Military/Foreign';
import Intro from 'components/Section/Military/Intro';
import Review from 'components/Section/Military/Review';
import { rootSelectors } from '@redux/modules/selectors';
import SectionNotFound from '../shared/SectionNotFound';

const Military = function ({
  subsection, location, formType, isReview
}) {
  const subsectionLibrary = {
    intro: Intro,
    selective: Selective,
    history: History,
    disciplinary: Disciplinary,
    foreign: Foreign,
    review: Review,
  };

  const form = formTypes[formType];
  const section = form.find((s) => s.key === MILITARY);
  const subsectionClasses = `view view-${subsection.name || 'unknown'}`;
  const title = isReview && i18n.t('review.title');
  const para = isReview && i18n.m('review.para');

  return (
    <div className="section-view">
      {title && <h1 className="title">{title}</h1>}
      {para}

      <div className={subsectionClasses}>
        {isReview && (
          <div className="top-btns">
            <ErrorList />
          </div>
        )}

        <Switch>
          {section.subsections.map((sub) => (
            <Route
              key={sub.key}
              path={`/form/${section.path}/${sub.path}`}
              component={subsectionLibrary[sub.name]}
            />
          ))}
          <Route component={SectionNotFound} />
        </Switch>

        <SectionNavigation currentPath={location.pathname} />
      </div>
    </div>
  );
};

/**
 * @param {import('types/state').RootState} state
 */
const mapStateToProps = (state) => ({
  subsection: state.section.subsection,
  isReview: rootSelectors.section.getIsSectionInReview(state),
  formType: rootSelectors.application.getFormType(state),
});

Military.defaultProps = {
  subsection: {},
  location: {},
};

Military.propTypes = {
  subsection: PropTypes.object,
  isReview: PropTypes.bool,
  location: PropTypes.object,
  formType: PropTypes.string.isRequired,
};

export var MilitarySections = function () {
  return <Review />;
};

export default connect(mapStateToProps)(Military);
